import { gluer } from 'femo';
const initUsers = [];
const users = gluer(initUsers);
export default users;
